export enum StoreCategory {
  Ecommerce = 'Ecommerce',
  Media = 'Media',
}
